interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const TelIcon = (props: PropsType) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.17625 3.85739C2.19197 4.71407 2.29064 6.94175 2.95379 8.67474C3.47028 10.0243 4.41317 11.7991 5.8056 13.3989C7.11552 14.9039 8.82587 16.1773 10.0913 16.875C11.7162 17.7708 13.909 18.1757 14.8932 17.3191C15.391 16.8859 16.0675 15.7992 16.08 15.6196C16.08 15.6196 15.498 14.951 15.3703 14.8044L13.4189 12.5623C13.2738 12.3957 12.5514 12.6693 12.2027 12.9377C11.7324 13.3 11.3717 14.1442 11.3717 14.1442C11.0497 14.3965 10.7275 14.2364 10.0738 14.041C9.27038 13.8009 8.26954 12.843 7.45623 11.9621C6.69601 11.0351 5.88524 9.91168 5.75825 9.0829C5.65488 8.40851 5.54068 8.06719 5.83494 7.78315C5.83494 7.78315 6.72087 7.54229 7.14453 7.12648C7.45853 6.81819 7.8291 6.14034 7.68408 5.97374L5.73264 3.7317C5.60495 3.58499 5.02302 2.91643 5.02302 2.91643C4.84356 2.90394 3.67393 3.42419 3.17625 3.85739Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6713 10.2835C16.9858 6.69095 14.4211 3.46314 10.8505 2.95748L10.9761 1.86116C15.1513 2.43641 18.151 6.21175 17.7676 10.409L16.6713 10.2835ZM14.2955 10.0111C14.462 7.72819 12.8401 5.68686 10.5786 5.33306L10.7042 4.23637C13.5703 4.66029 15.6271 7.24897 15.3922 10.1367L14.2955 10.0111ZM10.3063 7.7124C11.2588 7.90965 11.9396 8.76654 11.9165 9.73904L13.0153 9.86486C13.1034 8.2873 11.9887 6.88429 10.4321 6.61356L10.3063 7.7124Z"
        fill="black"
      />
    </svg>
  );
};

export default TelIcon;
